export var OPENING_FONT_FAMILY_TAG_REGEX = /^{\s*font\s*:\s*"?([a-zA-Z0-9_ ]*|[a-zA-Z0-9]*)"?}/;
export var CLOSING_FONT_FAMILY_TAG_REGEX = /^{\s*font\s*}/;
export var TOKEN_TYPE = 'font_family_text';
export var MARKUP = '{font}';
export var STYLE_TAG_TYPE = 'font-family';